import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">
        <strong>Effective Date:</strong> August 6, 2025
      </p>

      <p className="mb-4">
        At <strong>PlaysWithGuru</strong> (“we,” “our,” or “us”), your privacy
        is important. This Privacy Policy explains how we collect, use, and
        protect your information across our services, including the Prop Market,
        Stock Market, Clearance Market, Real Estate Market, and all other data
        analytics tools and content we provide.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">1. Information We Collect</h2>
      <p className="mb-4">We may collect the following types of information:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Personal identifiers (such as your name and email address)</li>
        <li>Authentication credentials via Google or Firebase</li>
        <li>Device and usage data (IP address, browser type, device ID)</li>
        <li>Interaction data (pages visited, features used)</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-2">2. How We Use Information</h2>
      <p className="mb-4">We use your information to:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Provide and personalize our analytics and education services</li>
        <li>Improve platform performance and user experience</li>
        <li>Communicate with you about updates, products, and offers</li>
        <li>Ensure security and prevent unauthorized access</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-2">3. Sharing Your Information</h2>
      <p className="mb-4">
        We do not sell or rent your personal information. We may share your data
        with trusted third-party service providers (e.g., Google Firebase) for
        authentication, analytics, or payment processing — only to support our
        platform and in compliance with applicable laws.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">4. Cookies & Analytics</h2>
      <p className="mb-4">
        Our platform may use cookies or similar technologies to enhance
        performance and analyze usage. By using our services, you consent to the
        use of such technologies.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">5. Data Security</h2>
      <p className="mb-4">
        We implement appropriate technical and organizational safeguards to
        protect your data. However, no method of transmission or storage is
        completely secure.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">6. Your Choices</h2>
      <p className="mb-4">
        You may request access to, update, or delete your personal data by
        contacting us at <strong>playswithguru@gmail.com</strong>. If you use
        Firebase or Google authentication, you may also manage your data
        directly with those services.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">7. Children’s Privacy</h2>
      <p className="mb-4">
        PlaysWithGuru is not intended for children under the age of 13. We do
        not knowingly collect personal data from children.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">8. Updates to This Policy</h2>
      <p className="mb-4">
        We may update this Privacy Policy from time to time. The most current
        version will always be available on this page. Your continued use of our
        services signifies acceptance of the updated terms.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-2">9. Contact Us</h2>
      <p>
        For questions or concerns, please contact us at: <br />
        <strong>Email:</strong> playswithguru@gmail.com <br />
        <strong>Website:</strong> <a href="https://playswithguru.com" className="text-blue-600 underline">https://playswithguru.com</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
